import React from 'react';

const ArrayOfStringsBlock = (props) => {
    const { json, dataObj, selectedStep  } = props;

    return (
        <div  style={{ marginTop: "5px" }}>
            <div style={{  }}>
                {
                    dataObj?.findings && dataObj.findings.length ? dataObj.findings.map((str, index) => (
                        <div key={index}  style={{ fontSize: "14px", lineHeight: "2rem" }}>{str}</div>
                    )) :
                    <div>
                        <p>No Data</p>
                    </div>
                }
            </div>
        </div>
    );
};

export default ArrayOfStringsBlock;